import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import type { IReboPipelineDetail } from 'src/types/rebo-pipeline';

export interface IReboPipelineLiveState {
  isLoading: boolean;
  hasError: boolean;
  error: string;
  currentEvent: IReboPipelineDetail | null;
}

const initialState: IReboPipelineLiveState = {
  isLoading: false,
  hasError: false,
  error: '',
  currentEvent: null,
};

export const reboPipelineLiveSlice = createSlice({
  name: 'rebo-pipeline-live',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.isLoading = true;
      state.hasError = false;
      state.error = '';
      state.currentEvent = null;
    },
    hasError: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.hasError = true;
      state.error = action.payload;
    },
    stopLoading: (state) => {
      state.isLoading = false;
    },
    setLiveEvent(state, action: PayloadAction<IReboPipelineDetail | null>) {
      state.currentEvent = action.payload;
      state.isLoading = false;
    },
    clearLiveEvent: (state) => {
      state.currentEvent = null;
      state.isLoading = false;
      state.hasError = false;
      state.error = '';
    },
  },
});

export const {
  startLoading,
  stopLoading,
  hasError,
  setLiveEvent,
  clearLiveEvent,
} = reboPipelineLiveSlice.actions;

export default reboPipelineLiveSlice.reducer;

